import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Container,
  VStack,
  Flex,
  Heading,
  Text,
  Image,
  Stack,
  Box,
} from '@chakra-ui/react';

import { LANDING_SCREEN_PATH } from '../support/routeConstants';
import { LandingScreen } from '../features/landing/landingScreen';
import { useAppDispatch } from '../app/hooks';
import { images } from '../support/imageSupport';
import { NavigateParams, BtNavigate } from './BtNavigate';
import { RootState } from '../app/store';
import { useSelector } from 'react-redux';

export interface FailedParams {
  status?: string;
  body?: string;
}

interface FailedProps {
  status?: string;
  body?: string;
}

const navigation: NavigateParams = {
  back: { title: '', image: 'ico_back_arrow', visible: true },
  home: { title: '', image: 'ico_home', visible: true },
  image: null,
};

const BtFailed: FunctionComponent<FailedProps> = ({ body, status }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const logoUrl = useSelector((state: RootState) => state.gatInformation.logoUrl);
  const { t } = useTranslation();

  async function handleNavigate() {
    dispatch(await LandingScreen.reset(logoUrl));
    navigate(LANDING_SCREEN_PATH);
  }

  return (
    <>
      <Container padding={0} size='xl'>
        <BtNavigate {...navigation} onClick={() => handleNavigate()} />
        <Container padding={0} maxW='container.md'>
          <Flex pb={200}>
            <VStack w='full' h='full' p={10}>
              <Image src={images('ico_error')} />
              <Stack
                w='100%'
                spacing={5}
                direction={['column', 'column']}
                p={4}
                alignItems='center'
              >
                <Heading as='h1' variant='h1'>
                  {t('failed.title')}
                </Heading>
                <Text>{t('failed.body')}</Text>
                <Button variant='primary' size='lg' w='full' onClick={() => handleNavigate()}>
                  {t('failed.ok')}
                </Button>
                <Box w='100%' p={4} bg='black' borderRadius='lg' boxShadow='brand'>
                  <Text>{t('failed.systemError')}</Text>
                  <Text>{status}</Text>
                  <Text>{body}</Text>
                </Box>
              </Stack>
            </VStack>
          </Flex>
        </Container>
      </Container>
    </>
  );
};

export default BtFailed;
